import styled from "styled-components";

import { colors } from "@ntemarked/mittne-components";

import { formatNumber, monthLabel } from "pages/Sikring/sikringUtils";

interface MonthlyVolume {
	/** Månedsnøkkel på formatet yyyy-MM. */
	maaned: string;
	volumKwh: number | null | undefined;
}

interface MonthlyVolumeListProps {
	volumes: MonthlyVolume[];
}

/** Volum per måned. Volumet er høyrejustert, så tallene og «kWh» står på linje uansett antall siffer. */
export function MonthlyVolumeList({ volumes }: Readonly<MonthlyVolumeListProps>) {
	return (
		<MonthList>
			{volumes.map((m) => (
				<MonthRow key={m.maaned}>
					<span>{monthLabel(m.maaned)}</span>
					<Volume>{formatNumber(m.volumKwh)} kWh</Volume>
				</MonthRow>
			))}
		</MonthList>
	);
}

// Uten tak strekker radene seg over hele bredden, og volumet havner langt fra måneden.
const MonthList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	max-width: 320px;
`;

const MonthRow = styled.div`
	display: grid;
	grid-template-columns: 90px 1fr;
	gap: 10px;
	align-items: center;
	font-size: 0.8125rem;
	color: ${colors.grey800};
	padding: 8px 12px;
	border-radius: 6px;
	box-shadow: inset 0 0 0 1px ${colors.grey300};
`;

const Volume = styled.strong`
	text-align: right;
	font-variant-numeric: tabular-nums;
`;
